/**
 * Single source of truth for the copy shown when conversational search is unavailable for the
 * current content type. It is surfaced in three places — the toggle's `aria-label`, the dedicated
 * CTA button's label, and the tooltip body — which must never drift apart.
 *
 * The supported set mirrors `isConversationalSearchEnabledForContentClass`: the video family, plus
 * audio and images when their flags are on. The message must be derived from those same flags
 * rather than hardcoded, otherwise it claims a content type is unsupported while the gate actually
 * permits it.
 */
export function getConversationalSearchUnavailableMessage(
  showConversationalSearchAudio: boolean,
  showConversationalSearchImages: boolean = false
): string {
  const supportedContent = [
    'video',
    ...(showConversationalSearchAudio ? ['audio'] : []),
    ...(showConversationalSearchImages ? ['image'] : []),
  ];
  return `Conversational Search is only available for ${formatList(
    supportedContent
  )} content.`;
}

function formatList(items: readonly string[]): string {
  if (items.length <= 2) return items.join(' and ');
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}
